import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=4245a1f0&"
import script from "./DataTable.vue?vue&type=script&lang=ts&"
export * from "./DataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../voice.mave.work/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports